import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';


import Video from 'video.js'
import 'video.js/dist/video-js.css'
import api from './api/api';
Vue.prototype.$video = Video


Vue.use(Vant);
Vue.use(ElementUI);
Vue.prototype.$api = api;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
